// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__iMr2i","name":"Nav_name__r+izr","links":"Nav_links__MwC2F","active":"Nav_active__IBB1P"};